<package-receive-progress></package-receive-progress>

<div class="steps-content">
  <p-card>
    <ng-template pTemplate="title">
      Shipper Information
    </ng-template>
    <ng-template pTemplate="subtitle">
      Provide information about the shipment
    </ng-template>
    <ng-template pTemplate="content">
      <div class="row">
        <div class="col-5 h4">
          Shipment Type
        </div>
        <div class="col-7 h4">
          Delivery Date
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div *ngFor='let item of package.shipmenttypes;let i = index' class="pl-2 pt-1" [ngClass]="{'selRadio' : item.selected}">
            <input id="shipmenttype_{{i}}" type="radio" [checked]="item.selected" (click)='radioChecked(item.value,i)' class="mr-3" /> <label for="shipmenttype_{{i}}" class="font-weight-bold">{{item.label}}</label>
          </div>
          <div class="grid p-nogutter justify-content-between w-full mt-6">
            <button class="navbutton w-5" (click)="prevPage()" icon="pi pi-angle-left">Back</button>
            <button class="navbutton w-5" (click)="nextPage()" icon="pi pi-angle-right" iconPos="right">Next</button>
          </div>
        </div>
        <div class="col-6">
          <p-datepicker name="dateDelivered" inline="true" #dateDelivered="ngModel" [(ngModel)]="package.DeliveredDate" [minDate]="minDateValue" [maxDate]="maxDateValue" hourFormat="12" [showTime]="true"></p-datepicker>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
    </ng-template>
  </p-card>
</div>
<p-toast>
</p-toast>
